<template>
  <div>
    <div class="c-base-transaction-details__price">
      <div class="c-base-transaction-details__icon">
        <base-icon width="24" height="24" :name="icon" />
      </div>
      <div class="c-base-transaction-details__amount">
        {{ transaction.amount | currency }}
      </div>

      <p class="c-base-transaction-details__category">
        <strong>Recebimento de presente</strong>
        <br />
        <small>Realizada em {{ transaction.created_at | date }}</small>
      </p>
    </div>

    <div class="c-base-transaction-details__body">
      <div class="columns is-mobile is-gapless is-multiline margin-bottom">
        <div class="column is-half">
          <p class="is-size-6">
            <strong>Valor do presente</strong>
          </p>
        </div>
        <div class="column is-half has-text-right">
          <strong class="has-text-support is-size-6">
            {{ transaction.amount | currency }}
          </strong>
        </div>
      </div>

      <div class="columns is-mobile is-gapless is-multiline margin-bottom">
        <div class="column">
          <p class="margin-bottom">
            Referente ao presente<br />
            <strong>{{ transaction.details.gift_name }}</strong>
          </p>

          <p>
            De {{ transaction.details.guest_name }}<br />
            Em {{ transaction.created_at | dateGiftPurchased }}
          </p>
        </div>
      </div>

      <div class="c-base-transaction-details__footer">
        <p class="is-size-6">
          Código da transação
          <br />
          <strong>
            {{ transaction.transaction_id }}
          </strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'
import BaseTransactionDetailsMixin from '@/mixins/BaseTransactionDetailsMixin'

export default {
  mixins: [BaseTransactionDetailsMixin],

  props: {
    transaction: {
      type: Object,
      required: true,
    },
    icon: String,
  },

  filters: {
    dateGiftPurchased(date) {
      const before3Days = new Date(date)
      before3Days.setDate(before3Days.getDate() - 3)
      return format(before3Days, 'DD/MM/YYYY')
    },
  },
}
</script>
